import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

import styled from '@emotion/styled'
import PrescriptionBox from './PrescriptionBox.js';


const ProfessionalWrapper = styled.div`
    /* padding-bottom:12rem; */
    transform: translateY(0);
        
    display: flex;

    height: 100%;
    width: 100%;
    padding-bottom: 10rem;

    .header--image--blue{

        
        position:relative;
        bottom: 8rem;
        justify-self: start;
        z-index: 1;
        right: 5rem;
    }
    .header--image--orange{
    
        margin: 0;
        
        justify-self: start;
        border-radius:var(--space-32);
        position: relative;
        right: var(--space-20);
        top: 1rem;
        z-index: 1;
        right: 7rem;
    }
 .blue-wave{
        position: absolute;
        top: 8rem;
        right: 20rem;
        z-index: 1;
    }
 .orange-wave{
        
        z-index: 1;
        position: absolute;
        top: 15rem;
        right:-2rem;
    }
    @media (max-width: 768px){
        .main--header--text{
        position:absolute;
        top:12rem;
        line-height:var(--space-40);
      
    }
    .header--annotation{
        position:absolute;
        top:12rem;
        font-size:1.5rem;
       
    }
    .header--image--blue{
        position:relative;
        width:10rem;
        bottom:6rem;
      
    }
    .header--image--orange{
        width:12rem;
        bottom:5rem;
     
    }
    .orange-wave{
        left: 28rem;
        top: 9rem;
        width: 12rem;
    }
    .blue-wave{
        top: 0rem;
        right: 7rem;
        width: 16rem;
    }
    }
    @media (max-width: 500px){
        width: 90vw;
    
    .header--image--blue{
        position:relative;
        width:8rem;
        bottom:6rem;
        left:0rem;
    
    }
    .header--image--orange{
        width:12rem;
        bottom:4rem;
        left:2rem;
    }
    .main--header--text{
        position:absolute;
        top:7rem;
        width:16rem;
        font-size:1.8rem;
        line-height:var(--space-40);
    }
    .header--annotation{
        position:absolute;
        top:10rem;
        font-size:1.2rem;
    }
    .orange-wave{
        left: 19rem;
        top: 6rem;
        width: 15rem;
    }
    .blue-wave{
        top: 0rem;
        right: 0rem;
        width: 12rem;
    }
    @media (max-width: 400px){
        .header--image--blue{
        
        }
        .header--image--orange{
            
        }
        .main--header--text{
            top: 9rem;
        }
        .header--annotation{
            top:12rem;

        }
        .orange-wave{
            left: 14rem;
        }
        .blue-wave{
            right: 2rem;

        }
    }
}
`;

const ProfessionalContainer = styled.div`
    align-self: end;
    .main--header--text{
        
        width: 38rem;
        height: fit-content;
    
        padding: 0;
        margin: 0;
        padding-bottom: var(--space-24);
        line-height: 52px;
        font-family: Inter, sans-serif;
        
        font-weight: 500;
        font-size: 3rem;
        
        color: var(--company-dark);
    
        position: relative;
    
        z-index: 2;
        left: 0rem;
    }
    @media only screen and (max-width: 500px){
        .main--header--text{
            width: 90vw;
            font-size: 2.5rem;
        }
    }
    .header--annotation{
        
        height: auto;
        width: auto;

        font-family: Inter, sans-serif;
        font-size: 1.5rem;
        line-height: 4vh;

        padding: 0;
        margin: 0;

        grid-row: 7;
        grid-column: 1/span all;

        position: relative;

        z-index: 2;
        left: 0rem;
    }
`;

const ProfessionalWave = styled.div`
    display: flex;
    height: 100%;
    width: fit-content;
    position: absolute;
    z-index: 1;
    
    left:10rem;
    .blue-wave{
        z-index: 1;
        position: relative;
        bottom:10rem;
    }
    .orange-wave{
     
        z-index:0;
        
    }
`;

const HeaderButton = styled.div`
    display: flex;
    min-height: fit-content;
    position: relative;
    right: 3rem;
    min-width: fit-content;
    padding: 2rem;

    .contact--btn{
        min-width: 20rem;
        height: 3rem;
        z-index: 3;
        color: var(--color-white);
        
        background-color: var(--hero-button);
        box-shadow: 0px 2px 6px rgba(16, 216, 197, 0.16), 0px 6px 15px rgba(16, 216, 197, 0.34);
        border-radius: 2.75rem;
        
        padding: 0;
        margin: 0;
        
        font-size: 1rem;
        font-weight: 500;
        font-family: Inter, sans-serif;
        
        transition: all 1s;
        left: 1rem;
        position: relative;
        margin-top: 5rem;
    }
    .header--graphic{
        position:absolute;
        height: auto;
        width: auto;
        z-index: 2;
        transform: scale(1);
        top: 8rem;
        left: 1.6rem;
    }
    @media (max-width: 768px){
        top:13rem;
        .header--graphic{
            left:1rem;
        }
    }
    @media (max-width: 500px){
        top:12rem;
        transform: scale(0.9);
        .header--graphic{
            left:1rem;
        }
        padding: 0;
        right: 2rem;
        width: 90vw;
        justify-content: flex-end;
    }
`;
const PrescriptionWrapper = styled.div`
    transform: translateY(0);
            
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;


    .main--header--text{
        width: 28rem;
        height: fit-content;



        padding: 0;
        margin: 0;

        line-height: var(--space-48);
        font-family: Inter, sans-serif;
        
        font-weight: 500;
        font-size: 40px;
        
        color: var(--company-dark);
    }
    .header--annotation{
        color: var(--color-gray-700);
        height: auto;
        width: 31rem;
    
        font-family: Inter, sans-serif;
        font-size: 1.5rem;
        line-height: 4vh;
    
        padding-top: 3rem;
        margin: 0;

    }
    .header--image{
        width: 16.7rem;
        height: 16.9rem;
        transform: scale(1.2);
        transition: transform 0.7s;
        position: relative;
        left: 3rem;
    }
    .box{
        margin-top: 10rem;
       position: relative;
    }
    > .header--graphic{
        position:absolute;
        right:61rem;
        bottom:2rem;
    }
    > .header--graphic--second{
        position:absolute;
        right:1rem;
        bottom:8rem;

    }

@media (max-width: 1100px){
        .header--image{

        }
}
@media (max-width: 800px){
    .main--header--text{
        position:relative;
    }
    .header--annotation{
        position:relative;
    }
    .header--graphic{
        display:none;
    }
    .header--graphic--second{
        display:none;
    }
    .header--image{
        position:relative;
        width:10rem;
        left: 15rem;
    }
    /* .box{
        position:relative;
        right:5rem;
        
    } */
}
    @media (max-width: 500px){
        .main--header--text{
            width: inherit;
            font-size:var(--font-28);
            /* left: 2rem; */
        }
        .header--annotation{
            width: inherit;
            font-size:var(--font-20);
            /* left: 2rem; */
        }
        .header--image{
            position: relative;
            left: 6rem;
            bottom: 9rem;
            display: none;
        }
    }

`;

const PresscriptionContainer = styled.div`
    display: flex;
    position: relative;
    top: 5rem;
    left: 8rem;
    width: 75%;
    justify-content: space-between;
    align-items: center;
    .header-container{
        flex-direction: column;
    }
    @media only screen and (max-width: 500px){
        left: 0;
        width: 90vw;
    }
`;

function Hero() {
    const location = useLocation();
    const [hero, setHero] = useState(true);

    const professionals = () => {
        return (
         
            <ProfessionalWrapper>
                <ProfessionalContainer>
                    <div className="main--header--text">
                        <span>Our Team of Professionals are here to help</span>
                    </div>
                    <div className="header--annotation">
                        <span>Our Service, Your Success</span>
                    </div>
                    <HeaderButton>
                        <Link to={"/contact"}><button type className="contact--btn">Contact Us for More Details</button></Link>
                        <img className="header--graphic" src="/header/frame-144.png"/>
                    </HeaderButton>
                </ProfessionalContainer>
                <img className="blue-wave" alt="blue wave" src="/header/blue-wave.jpg"/>
                <img className="orange-wave" alt="orange wave" src="/header/orange-wave.jpg"/>
                <img className="header--image--blue" src="/header/header1.jpg" alt="blue container"/>
                <img className="header--image--orange" src="/header/header2.jpg" alt="orange container"/>

            </ProfessionalWrapper>
        );
    };



    const prescription = () => {
        return (
            
                    <PrescriptionWrapper>
                        <PresscriptionContainer>
                            <div className="header-container">
                                <div className="main--header--text">
                                    <span>Need help filling your prescription?</span>
                                </div>
                                <div className="header--annotation">
                                    <span>Give us your phone number, a picture of your prescription and we’ll take it from there.</span>
                                </div>
                            </div>
                            <img alt="Prescription Illustration" src="/header/prescription-illustration.svg" className="header--image"/>
                        </PresscriptionContainer>
                        <div className="box">
                            <PrescriptionBox/>
                        </div>
                    </PrescriptionWrapper>
              );
    };


    return (
            <div>
                {location.state && location.state.page ?
                    <div>
                        {professionals()}
                    </div> :
                    <div>
                        {prescription()}
                    </div>
                }
            </div>

    );

}

export default Hero;
